if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"freya_project_ui","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(8(20|514|576)|2760|6207|7212|9069)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}